// src/features/userGuideSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getGuideTitles,
  getGuideDetail,
} from "../../services/dashboardServices";

export const fetchTitles = createAsyncThunk(
  "userGuide/fetchTitles",
  async () => await getGuideTitles()
);

export const fetchDetail = createAsyncThunk(
  "userGuide/fetchDetail",
  async (id, { getState }) => {
    const { details } = getState().userGuide;
    if (details[id]) return details[id]; // cache hit
    return await getGuideDetail(id);
  }
);

const userGuideSlice = createSlice({
  name: "userGuide",
  initialState: {
    titles: [],
    details: {}, // { [id]: { id, title, content, video_iframe } }
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTitles.fulfilled, (s, { payload }) => {
        s.titles = payload;
      })
      .addCase(fetchDetail.fulfilled, (s, { payload }) => {
        s.details[payload.id] = payload;
      });
  },
});

export default userGuideSlice.reducer;
